// ButtonTag.js
import React from 'react';

const Button = ({type, text, children, className, id, name, onClick,disabled, areaLabel ,...props}) => (
  <button
  type={type}
    className={className}
    id={id}
    name={name}
    onClick={onClick}
    aria-label={areaLabel}
    disabled={disabled}
  >
    {text}
    {children}
  </button>
);

export default Button;
